import { HttpClient, ListParams } from './http-client';
import { Observable } from 'rxjs';
import Barn from '../interfaces/barn';
import Paginate from '../interfaces/paginate';

export class BarnService extends HttpClient {
  index(farmId: string, params?: ListParams): Observable<Paginate<Barn>> {
    return this.get<Paginate<Barn>>(
      `/api/farms/${farmId}/livestock/barn`,
      params
    );
  }

  show(farmId: string, id: string): Observable<Barn> {
    return this.get<Barn>(`/api/farms/${farmId}/livestock/barn/${id}`);
  }

  update(farmId: string, id: string, barn: Barn): Observable<Barn> {
    return this.put<Barn>(`/api/farms/${farmId}/livestock/barn/${id}`, barn);
  }

  syncBarns(farmId: string): Observable<any> {
    return this.post<null>(`/api/farms/${farmId}/livestock/barn/sync`);
  }
}
